import Footer from "../components/Footer";
import Header from "../components/Header";

const ReturnPolicy = () => {
    return (
        <div>
            <Header />
            <div className="mx-auto px-5 pt-[calc(61px+76px)] pb-[76px] md:pt-[calc(74px+100px)] md:pb-[100px] relative bg-[#1A1A1A]">
                <div className="text-center text-[32px] leading-[110%] md:text-[45px] text-white md:leading-[52.5px] uppercase font-bold">
                    Return<br className="md:hidden" /> Policy
                </div>
                <div className="flex items-center justify-center text-[12px] leading-[170%] md:text-[10.5px] md:leading-[18px] text-white uppercase mt-4">
                    <div>Policy</div>
                    <div className="w-[12px] bg-[#1AB6F9] h-[1px] mx-2 md:mx-4"></div>
                    <div>Return Policy</div>
                </div>
            </div>
            <div className="flex items-center justify-center my-[28px] md:my-[54px] bg-[#141414] text-white text-[17.72px] leading-[31px] uppercase">
                <div className="px-4 md:px-0 md:w-[940px]">
                    <p>Effective Date: [Insert Date]</p>

                    <p className="pl-4">By registering for an account on cardshopexchange.com, you agree to be bound by this Return Policy.</p>
                    <p className="pl-4">Items may be returned if they are not as described. If you wish to return an item for any other reason, the seller must agree to accept the return.</p>
                    <p className="pl-4">Send the seller a message with details of the issue and why you would like to return the item. If the seller doesn’t respond within three business days, you can reach out to [e-mail] for support.</p>
                    <p className="pl-4">To contact the seller:</p>

                    <p>[directions]</p>

                    <p className="pl-4">If the seller accepts your request for a return, the seller will send a return shipping label to the email address associated with your account, or you may need to provide your own label depending on the seller. Once you have your return shipping label, you will need to print it, attach it to the package and drop the package off at the correct carrier within three business days.</p>
                    <p className="pl-4">If the returned item is not in the condition in which it was received or is damaged during return shipping because it wasn’t packaged correctly, the seller may deduct from the refund to cover the loss in the item’s value.</p>
                    <p className="pl-4">If you believe another user has violated this Return Policy, you may e-mail us at [e-mail]. If we determine that a violation has occurred, we will take all appropriate action we deem necessary to address the violation. The Company will take no action to enforce any legal remedy you may have against another user.</p>
                    <p className="pl-4">We reserve the right to modify this Return Policy at any time. We will notify Users of any material changes by: (a) posting the updated Return Policy on the Site with a new effective date; and (b) Sending an email to the address associated with your account.</p>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ReturnPolicy;
